<template>
  <div :style="'background-color:' + pageColor">
    <ProjectHeader>
      <img src="./cmhof-hero@2x.jpg" alt="Brentwood Academy">
    </ProjectHeader>
    <Summary :backgroundColor="summaryColor">
      <div slot="left">
        <h2 class="subtitle">Client</h2>
        <div class="content">
          <p>Country Music Hall of Fame</p>
          <br>
        </div>

        <h2 class="subtitle">My Role</h2>
        <div class="content">
          <p>User Experience</p>
          <p>UI Design</p>
        </div>

      </div>
      <div slot="right">
        <h2 class="subtitle">Summary</h2>
        <div class="content">
          <p>
            The Country Music Hall of Fame and Museum wanted to change digital platforms and took the opportunity to
            rethink their website and combine their four properties into one seamless experience.
          </p>
        </div>
      </div>
    </Summary>
    <div class="section">
      <div class="container">
        <img src="./HoF-macbook@2x.png" alt="">
      </div>
    </div>
    <ProjectGoals :color="primaryColor">
      <p slot="goal1">Increase ecommerce transactions.</p>
      <p slot="goal2">Increase time spent on site.</p>
      <p slot="goal3">Improve user experience in events calendar.</p>
    </ProjectGoals>
    <OffsetGallery accentColor="has-accent-light-tan">
      <div slot="col1">
        <img src="./Screen-L@2x.png" alt="">
      </div>
      <div slot="col2">
        <img src="./Screen-R@2x.png" alt="">
      </div>
    </OffsetGallery>
    <div class="section-spacer"></div>

    <SimpleSection title="Sitemaps" :titleColor="primaryColor">
      The client wanted to carry over all existing pages to their new system. We needed to make sure we accounted for
      all pages while improving the information architecture.
    </SimpleSection>
    <offset-gallery>
      <div slot="col1">
        <img src="./CMHOF-Sitemap.png" alt=""/>
        <img src="./CMATheater-Sitemap.png" alt=""/>
      </div>
      <div slot="col2">
        <img src="./Hatch-Sitemap.png" alt=""/>
        <img src="./StudioB-Sitemap.png" alt=""/>
      </div>
      <div class="section-spacer"></div>

    </offset-gallery>
    <div class="section-spacer"></div>

    <SimpleSection title="Wireframes" :titleColor="primaryColor">
      To optimize budget and timeline, we divided wireframe and content types across the four sites that could all be
      used interchangeably.
    </SimpleSection>

    <div class="section no-side-padding">
      <img src="./HoF-wireframes@2x.png" alt="">
    </div>
    <div class="section-spacer"></div>

    <SimpleSection title="Design" :titleColor="primaryColor">
      We worked with the internal design team to ensure we remained consistent to the brand recognition they had built
      while pushing the design forward.
    </SimpleSection>

    <offset-gallery class="has-accent-light-tan has-accent-center">
      <div slot="col1">
        <img src="./Screen-L@2x-design.png" alt=""/>
        <img src="./Screen-L@-design-2.png" alt=""/>
      </div>
      <div slot="col2">
        <img src="./Screen-R@2x-design.png" alt=""/>
        <img src="./Screen-R@2x.png-design-2.png" alt=""/>
      </div>
    </offset-gallery>
    <div class="section-spacer"></div>

    <SimpleSection title="Ticketing Experience" :titleColor="primaryColor">
      We integrated with their existing ticketing software through a REST API and utilized CSS to style the data calls
      to match the other UI elements of the site.
    </SimpleSection>
    <div class="section">
      <div class="container">
        <img src="./mobile-screens.png" alt="">
      </div>
    </div>
    <div class="section no-side-padding">
      <img src="./HoF-ticketing-img@2x.png" alt="">
    </div>
    <router-link to="/brentwood-academy">
      <BigButton backgroundColor="#616C78" subtitle="Next Project" title="Brentwood Academy"></BigButton>
    </router-link>
  </div>
</template>

<script>
  import Summary from '@/components/Summary'
  import ProjectHeader from '@/components/ProjectHeader'
  import ProjectGoals from '@/components/ProjectGoals'
  import BigButton from '@/components/BigAssButton'
  import SimpleSection from '@/components/SimpleSection'
  import OffsetGallery from '@/components/OffsetGallery'

  export default {
    components: {Summary, ProjectHeader, ProjectGoals, BigButton, OffsetGallery, SimpleSection},
    data() {
      return {
        primaryColor: '#EFB23A',
        summaryColor: '#ADA8A1',
        pageColor: '#EDECEB'
      }
    }
  }
</script>
